/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Sreality_ActionsInputs */

const cs_portals_sreality_actions = /** @type {(inputs: Portals_Sreality_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce portálu`)
};

const en_portals_sreality_actions = /** @type {(inputs: Portals_Sreality_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal actions`)
};

/**
* | output |
* | --- |
* | "Portal actions" |
*
* @param {Portals_Sreality_ActionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_sreality_actions = /** @type {((inputs?: Portals_Sreality_ActionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Sreality_ActionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_sreality_actions(inputs)
	return cs_portals_sreality_actions(inputs)
});